import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as moment from 'moment';
import { UserService } from '../services/user.service';
import { TableUtil } from '../admintrademaster/tableUtil';
import { NotificationsService } from 'angular2-notifications';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { WalletsService } from '../services/wallets.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AddEditMarketPrice } from './addeditmarketprices/addeditmarketprices.component';
// import * as moment from 'moment-timezone';
const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-marketprices',
    templateUrl: './marketprices.component.html',
    styleUrls: ['./marketprices.component.css']
})
export class MarketPricesComponent implements OnInit {
    liqpairs: any = [];
    public pairListSearchCopy: any = []
    displayedColumns = [
        'Action',
        'ExchangeName',
        'InternalPair',
        'BaseCurrency',
        'QuoteCurrency',
        'MarketPrice',
        'CurrentPrice',
        'Name',
        'Symbol',
        'Id',
        'Date',
        'LastUpdate',
    ];
    public dataSource = new MatTableDataSource();
    pageSize = 25;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    fromDate;
    toDate;
    filter: any = {};
    // csrf: any;
    public selectedDate = new Date();
    public selectedDate1 = new Date();

    constructor(
        private userService: UserService,
        private dialog: MatDialog,
        private notifSer: NotificationsService,
        private spinnerService: Ng4LoadingSpinnerService) { }

    ngOnInit() {
        this.filter['fDate'] = moment(this.selectedDate).format('YYYY-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('YYYY-MM-DD');
        this.getInternalPairList();
        this.displayMarketPrices();
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('YYYY-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('YYYY-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim();
        filterValue = filterValue.toLowerCase();
        this.dataSource.filter = filterValue;
    }
    getInternalPairList() {
        this.userService.getInternalPair().subscribe(response => {
            response = response.map(function (item) {
                return { pair: `${item.BaseCCY}${item.QuoteCCY}` };
            })
            this.liqpairs = response.map(item => item.pair)
                .filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a > b ? 1 : -1);
            this.pairListSearchCopy = this.liqpairs
        })
    }
    addEditMarketPrice(element) {
        let new_element = {}
        if (element) {
            new_element = {
                'MarketPrice': element.MarketPrice,
                'ExchangeName': element.ExchangeName,
                'BaseCurrency': element.BaseCurrency,
                'QuoteCurrency': element.QuoteCurrency,
                'Id': element.Id,
                '_id': element._id
            };
        } else {
            new_element = {
                'MarketPrice': '',
                'ExchangeName': '',
                'BaseCurrency': '',
                'QuoteCurrency': '',
                'Id': '',
                '_id': ''
            };
        }
        this.dialog.open(AddEditMarketPrice, {
            width: '500px',
            data: new_element,
        }).afterClosed().subscribe(result => {
            if (result && result.success) {
                this.displayMarketPrices();
            }
        });
    }
    pairsearch_manualtrade(event): void {
        let term = event;
        this.liqpairs = this.pairListSearchCopy.filter(function (tag) {
            if (tag.toLowerCase().indexOf(term.toLowerCase()) >= 0 || tag.toLowerCase().indexOf(term.toLowerCase()) >= 0) {
                return tag;
            }
        });
    }
    onOptionSelected(event) {
        this.filter['pair'] = event.option.value;
        if (event.option.value == 'ALL') this.filter['pair'] = '';
    }
    displayMarketPrices() {
        this.spinnerService.show();
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data['_csrf'];
            this.userService.getMarketPrices(this.filter).subscribe(data => {
                this.spinnerService.hide();
                this.dataSource = new MatTableDataSource(data);
                this.dataSource.paginator = this.paginator
                this.dataSource.sort = this.sort
            })
        })
    }
    async exportArray() {
        if (this.dataSource.filteredData) {
            const marketPrices = await this.dataSource.filteredData.map((x: any) => ({
                ExchangeName: x.ExchangeName,
                InernalPair: x.InternalPair,
                BaseCurrency: x.BaseCurrency,
                QuoteCurrency: x.QuoteCurrency,
                CurrentPrice: x.CurrentPrice,
                Name: x.Name,
                Symbol: x.Symbol,
                MarketPrice: x.MarketPrice,
                Id: x.Id,
                Date: x.Date,
                createdAt: x.createdAt

            }));
            TableUtil.exportArrayToExcel(marketPrices, "marketPrices");
        }

    }
}


// WEBPACK FOOTER //
// ./src/app/marketprices/marketprices.component.ts